export default "__VITE_ASSET__0abc910d__"